/**
 * レビュー分析のステータス
 */
const analysisStatus = {
  1: 'レビュー取得中',
  2: '取得完了',
  3: '分析中',
  4: '分析完了',
  8: 'レビュー不足',
  9: 'エラー'
}

export default analysisStatus
